module.exports = __webpack_public_path__ + "media/images/top-content-img-5-15c1da9c5f1b76f63fabf6ec6d0564da.jpg";